import React from 'react';
import { MaterialsPanel } from '../../components/shared/MaterialsPanel';
export function MemberMaterials() {
  return <div className="space-y-5" data-id="element-1676" data-mp="1z7q1ttabjoy2">
      <div data-id="element-1677" data-mp="1z6y3iapc7d43">
        <h1 className="text-2xl font-semibold text-ink" data-id="element-1678" data-mp="1z6ogmvzl9m2m">Gradiva zbora</h1>
        <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1679" data-mp="240j5edu1wr8k">Note, vadbeni posnetki in interni dokumenti.</p>
      </div>
      <MaterialsPanel data-id="element-1680" data-mp="290yfmwj1dimb" />
    </div>;
}